export type AnalyticsConsentValue = 'accepted' | 'rejected'

const ANALYTICS_CONSENT_STORAGE_KEY = 'laplace_analytics_consent'

export const getAnalyticsConsent = (): AnalyticsConsentValue | null => {
  const value = window.localStorage.getItem(ANALYTICS_CONSENT_STORAGE_KEY)

  if (value === 'accepted' || value === 'rejected') {
    return value
  }

  return null
}

export const setAnalyticsConsent = (value: AnalyticsConsentValue): void => {
  window.localStorage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, value)
}

export const clearAnalyticsConsent = (): void => {
  window.localStorage.removeItem(ANALYTICS_CONSENT_STORAGE_KEY)
}

export const hasAcceptedAnalyticsConsent = (): boolean => {
  return getAnalyticsConsent() === 'accepted'
}
